<template>
  <div class="hide-panel">
    <form class="hide-panel__form" @submit.prevent="registerhidePanel">
      <div class="hide-panel__line">
        <text-input
          :value="model.name"
          :name="$t('hidePanels.name')"
          :placeholder="$t('hidePanels.name')"
          :width="240"
          @change="model.name = $event"
        />
        <text-input
          :value="model.code"
          :name="$t('hidePanels.code')"
          :placeholder="$t('hidePanels.code')"
          :width="240"
          @change="model.code = $event"
        />
      </div>
      <div class="button-container">
        <button class="button-submit" type="submit">{{ $t('lk.save') }}</button>
      </div>
    </form>
    <div class="message">{{ message }}</div>
  </div>
</template>

<script>
import { api } from '@/api';
import { errorHandler } from '@/mixins';
import TextInput from '../../inputs/text-input/TextInput.vue';

export default {
  name: 'HidePanelRegister',
  components: { TextInput },
  mixins: [errorHandler],
  data() {
    return {
      message: '',
      model: {
        name: '',
        code: ''
      }
    };
  },
  methods: {
    registerhidePanel() {
      const data = { ...this.model };

      api
        .post('/hide-panels', JSON.stringify(data))
        .then((res) => {
          if (res.message) return this.messageHandler(`Error ${res.message}`);
          window.setTimeout(this.redirectTohidePanels, 1000);
          return this.messageHandler(this.$t('hidePanels.saveded_successfully'));
        })
        .catch((error) => {
          this.messageHandler(`Error ${error}`);
        });
    },
    redirectTohidePanels() {
      window.location.href = `${window.location.origin}/hide-panels`;
    }
  }
};
</script>

<style lang="scss">
.button-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.hide-panel {
  .message {
    padding-top: 20px;
  }

  &__form {
  }

  &__category-add {
    margin-bottom: 20px;
  }

  &__line {
    display: flex;
    margin: 0px 0px 20px 0px;
    .input__container {
      margin-bottom: 0;
    }
  }
  &__col {
    display: flex;
    flex-direction: column;
    max-width: 700px;
  }
  &__select {
    width: 240px;
  }
}
</style>
